import React from 'react';

type ActionVariant = 'primary' | 'secondary' | 'danger';

interface BulkAction {
  label: string;
  icon?: React.ReactNode;
  onClick: () => void | Promise<void>;
  variant?: ActionVariant;
}

interface BulkActionsBarProps {
  selectedCount: number;
  onBulkDelete: () => void | Promise<void>;
  onDeselectAll: () => void;
  additionalActions?: BulkAction[];
}

const variantClasses: Record<ActionVariant, string> = {
  primary: 'bg-blue-600 text-white hover:bg-blue-700',
  secondary: 'bg-gray-100 text-gray-700 hover:bg-gray-200',
  danger: 'bg-red-600 text-white hover:bg-red-700',
};

export const BulkActionsBar: React.FC<BulkActionsBarProps> = ({
  selectedCount,
  onBulkDelete,
  onDeselectAll,
  additionalActions = [],
}) => {
  if (selectedCount === 0) {
    return null;
  }

  return (
    <div className="sticky top-0 z-20 mb-4 flex flex-wrap items-center justify-between gap-3 rounded-lg border border-blue-100 bg-blue-50 px-4 py-3 text-sm text-blue-900 shadow-sm">
      <div className="font-medium">
        {selectedCount} {selectedCount === 1 ? 'record selected' : 'records selected'}
      </div>
      <div className="flex flex-wrap items-center gap-2">
        {additionalActions.map((action) => (
          <button
            key={action.label}
            className={`flex items-center gap-1 rounded px-3 py-1 text-sm font-medium transition-colors ${
              variantClasses[action.variant ?? 'secondary']
            }`}
            onClick={action.onClick}
          >
            {action.icon}
            {action.label}
          </button>
        ))}
        <button
          className={`rounded px-3 py-1 text-sm font-semibold transition-colors ${variantClasses.danger}`}
          onClick={onBulkDelete}
        >
          Delete Selected
        </button>
        <button
          className={`rounded px-3 py-1 text-sm font-medium transition-colors ${variantClasses.secondary}`}
          onClick={onDeselectAll}
        >
          Clear
        </button>
      </div>
    </div>
  );
};
